<template>
    <v-navigation-drawer
      v-model="showDrawer" absolute temporary
       app :width="width" right>
      <v-list dense>
        <v-card :elevation="`0`" class="elevation-0 mb-8" height="170">
            <v-list-item-group>
              <v-list-item-content class="text-right padding-0">
                    <v-list-item-subtitle class="mr-6 mt-4"><img src="../../assets/close.png" alt="close" width="18px" height="18px" @click="toggleMenu"> </v-list-item-subtitle>
                </v-list-item-content>
                 <v-list-item-content class="padding-0">
                    <v-list-item-avatar class="v-image" width='60px' height='60px' >
                        <img :src="userImage" alt="''" class="fitImage">
                    </v-list-item-avatar>
                </v-list-item-content>
                <v-list-item-content class="text-center">
                    <label class="name-title">{{ name }}</label>
                    <v-list-item-subtitle class="position-title mb-3">{{ section }}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item-group>
        </v-card>

        <v-list-item class="tile padding-0" v-for="item in this.items"
            :key="item.title" link>
            <v-list-item-content class="padding-1" @click="menuClicked(item.link)">
              <router-link to=""> 
                <a >{{item.title}}</a>
              </router-link>
            </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
</template>

<script>
import { ListEvents, DefaultValues, setLanguage} from "@/utilities/CommonUtilities";
import { mapState, mapActions } from "vuex";
import Vue from 'vue';

let unwatcher;
export default {
  data: function() {
    return {
      name: DefaultValues.none_string,
      section: DefaultValues.none_string,
      userImage:null,
      showDrawer: false,
      items: [
        { title: this.$i18n.t("menu_vacations"), link: "/" },
        { title: this.$i18n.t("profile_my_profile"), link: '/profile' },
        { title: this.$i18n.t("menu_abouts"), link: "/about" },
        { title: this.$i18n.t("common_logout"), link: "/login" }
      ]
    };
  },
  computed: {
      ...mapState(["userInfo"]),
      ...mapState({
            currentLanguage: state => state.homeData.currentLanguage,
        }),
      width() {
        return this.showDrawer ? 320 : 0;
      }
  },
  methods: {
    ...mapActions({
        signOut: "signOut"
    }),
    toggleMenu() {
      this.showDrawer = false;
    },
    menuClicked(link) {
      if(link == "/login") {
        this.signOut();
      }
      this.showDrawer = false;
      this.$router.push(link);
    },
    changeData() {
      this.name = this.userInfo != null ? this.userInfo.name : DefaultValues.none_string;
      this.section = this.userInfo != null ? this.userInfo.section : DefaultValues.none_string;
      if(this.userInfo && this.userInfo.profiolePhoto != null) {
        this.userImage = `data:image/png;base64,${this.userInfo.profiolePhoto}`;
      } else {
        this.userImage = DefaultValues.no_image;
      }

      if(this.userInfo) {
        this.items = [
          { title: this.$i18n.t("menu_vacations"), link: "/" },
          { title: this.$i18n.t("profile_my_profile"), link: '/profile' },
          { title: this.$i18n.t("menu_abouts"), link: "/about" },
          { title: this.$i18n.t("common_logout"), link: "/login" }
        ];
        Vue.set(this.items, 1, { title: this.$i18n.t("profile_my_profile"), link: '/profile/' + this.userInfo.userID});
      }
    }
  },
  created() {
    setLanguage(this.currentLanguage);
    this.notifyBus.$on(ListEvents.showRightMenu, () => {
      this.showDrawer = true;
    });

    unwatcher = this.$store.watch(state => state.userInfo, () => {
            this.changeData();
        });
    this.changeData();
  },
  beforeDestroy() {
    unwatcher();
  },
  inject: ["notifyBus"],
};
</script>

<style scoped>
.padding-0 {
  padding: 5px !important;
  margin: 4px;
}
.v-image {
  flex-direction: column;
}
.tile:hover {
  background: #f1bd42;
  color: white;
}
.tile:active {
  background: #f1bd42;
  color: white;
}

.tile:hover a{
  background: #f1bd42;
  color: white;
}
.tile a{
  color:#333333;
  text-align: left;
  text-decoration: none;
  margin-left: 15px;
}
.v-list-item__title {
  font-size: 1em !important;
}
.tile:active a{
  background: #f1bd42;
  color: white;
}

.text-center {
  padding-top: 5px;
}
.position-title {
  color: #c9c9c9;
  font-size: 14px;
  margin-top: 2px;
}
.name-title {
  color: #333333;
  font-size: 1.2em !important;
  font-weight:800;
}
.fitImage {
    object-fit: cover;
}
</style>
